import { Injectable, signal, Signal, WritableSignal, effect } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SignalStoreService {
  constructor() {}

  /**
   * Creates a persistent writable signal synced with localStorage.
   * @param key Storage key in localStorage.
   * @param defaultValue Default value if nothing exists in storage.
   */
  persistentSignal<T>(key: string, defaultValue: T): WritableSignal<T> {
    let initial: T;

    try {
      const stored = localStorage.getItem(key);
      initial = stored ? JSON.parse(stored) : defaultValue;
    } catch (err) {
      console.warn(`SignalStoreService: Error loading key ${key} from localStorage`, err);
      initial = defaultValue;
    }

    const sig = signal<T>(initial);

    // Automatically sync to localStorage when signal changes
    effect(() => {
      const value = sig();
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (err) {
        console.warn(`SignalStoreService: Error saving key ${key} to localStorage`, err);
      }
    });

    return sig;
  }

  /**
   * Deletes a signal value from localStorage.
   */
  clearPersistentSignal(key: string) {
    localStorage.removeItem(key);
  }
}
